module.exports = __webpack_public_path__ + "assets/img/succ2.603a0b9b.png";